import type { ServiceCategoryRow } from '@/api/booking/getServiceCategoriesQuery';
import type { Service } from '@/types/booking';

/** The `libraryKey` of the backend `Other` category (SQR-17078). */
export const OTHER_CATEGORY_LIBRARY_KEY = 'other';

export function getOtherCategoryRow(
  rows: ServiceCategoryRow[],
): ServiceCategoryRow | undefined {
  return rows.find((row) => row.libraryKey === OTHER_CATEGORY_LIBRARY_KEY);
}

/**
 * Puts every service without a category in the visible `Other` category, so
 * category-first lists treat it as a normal L2. Other services keep their
 * reference; with no visible `Other` row the input is returned as is.
 */
export function assignUncategorizedToOther(
  services: Service[],
  rows: ServiceCategoryRow[],
): Service[] {
  const other = getOtherCategoryRow(rows);
  if (!other || other.visible === false) return services;

  const categories = [
    {
      id: other.id,
      name: other.name,
      parentCategoryId: other.parentCategoryId,
      visible: other.visible,
    },
  ];
  return services.map((service) =>
    service.categories?.length ? service : { ...service, categories },
  );
}
